module.exports = __webpack_public_path__ + "media/images/patent/x_11-6cbc21306fa52a43c842ebe45e482b50.png";